<div class="data-import-container tml-responsive-panel">
    <div class="sub-chrome-container">
        <div class="title-area">
            <span class="h1-light text-ellipsis">{{pageTitle}}</span>
        </div>
        <div class="operation-box">
            <button tid="data-import-cancel-button" (click)="onBtnCancel()" tam-button [tamType]="'tertiary'"
                [tamSize]="'normal'">Cancel</button>
            <button tid="data-import-save-button" (click)="onBtnSave()" tam-button [tamType]="'primary'"
                [tamSize]="'normal'" [tamLoading]="isProgressing" [disabled]="isProgressing">Save</button>
        </div>
    </div>
    <div class="body">
        <form [formGroup]="flatfileForm">
            <div class="tam-form-field" [ngClass]="{'has-error': name.invalid}">
                <div class="form-width">
                    <div>
                        <span class="caption-1">{{'general.name' | stringLiterals}} <span
                                class="required warning-red">*</span></span>
                    </div>
                    <input type="text" class="tam-textbox" formControlName="name">
                    <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                        {{'general.required_error_message' | stringLiterals}}</div>
                    <div class="tam-form-help" *ngIf="name.invalid && name.errors['maxlength']">
                        {{'general.name_exceed_maximum' | stringLiterals: '64'}}</div>
                    <div class="tam-form-help" *ngIf="name.invalid && name.errors['duplicated']">
                        {{'general.name_in_use_change_another_one' | stringLiterals}}</div>
                </div>
            </div>
            <div class="tam-form-field form-width tam-textbox-description"
                [ngClass]="{'has-error': description.invalid}">
                <div>
                    <span class="caption-1">{{'general.description' | stringLiterals}}</span>
                </div>
                <textarea class="tam-textbox" formControlName="description"></textarea>
                <div class="tam-form-help" *ngIf="description.invalid && description.errors['maxlength']">
                    {{'general.exceed_maximum' | stringLiterals: 'Description' : '128'}}
                </div>
            </div>

            <div *ngIf="isFlatfile" class="tam-form-field form-width" [ngClass]="{'has-error': !isFileValid}">
                <div>
                    <span>{{'general.upload_flat_file' | stringLiterals}} <span
                            class="required warning-red">*</span></span>
                </div>
                <tam-upload [config]="uploadConfig"></tam-upload>
                <div class="tam-form-help" *ngIf="!isFileValid">{{'general.please_choose_a_csv' | stringLiterals}}
                </div>
            </div>

            <div *ngIf="isSqlmdl || isOraclemdl" class="tam-form-field sqlmdl-input">
                <div>
                    <span class="caption-1">{{(isSqlmdl ? 'general.sql_connection' : 'general.oracle_connection') |
                        stringLiterals}}</span>
                </div>

                <div class="form-group" formGroupName="mdlProperties">
                    <div class="column-setting">
                        <div class="tam-form-field mdl-input" [ngClass]="{'has-error': serverip.invalid}">
                            <label class="caption-2">{{'general.server_name_or_ip' | stringLiterals}} <span
                                    class="required warning-red">*</span></label>
                            <input type="text" class="tam-textbox" formControlName="serverip"
                                (keyup)="serverConfigChanged()"
                                [placeholder]="isOraclemdl? 'Server Name:Port/Service Name': ''">
                            <div>
                                <div class="tam-form-help">
                                    <span
                                        *ngIf="serverip.invalid && serverip.errors['required']">{{'general.required_error_message'
                                        | stringLiterals}}</span>
                                    <span *ngIf="isConnectSuccessMessageShow" class="success-message">
                                        {{'general.connect_successfully' | stringLiterals}} </span>
                                </div>
                            </div>
                        </div>
                        <div class="tam-form-field mdl-input" [ngClass]="{'has-error': loginUser.invalid}">
                            <label class="caption-2">{{'general.login_user' | stringLiterals}} <span
                                    class="required warning-red">*</span></label>
                            <input type="text" class="tam-textbox" formControlName="loginUser"
                                (keyup)="serverConfigChanged()" autocomplete="off">
                            <div>
                                <div class="tam-form-help" *ngIf="loginUser.invalid && loginUser.errors['required']">
                                    {{'general.required_error_message' | stringLiterals}}
                                </div>
                            </div>
                        </div>
                        <div class="tam-form-field mdl-input" [ngClass]="{'has-error': loginPassword.invalid}">
                            <label class="caption-2">{{'general.login_password' | stringLiterals}} <span
                                    class="required warning-red">*</span></label>
                            <input type="password" class="tam-textbox" formControlName="loginPassword"
                                (keyup)="serverPasswordChanged()" autocomplete="off">
                            <div>
                                <div class="tam-form-help"
                                    *ngIf="loginPassword.invalid && loginPassword.errors['required']">
                                    {{'general.required_error_message' | stringLiterals}}
                                </div>
                            </div>
                        </div>
                        <button tid="data-import-sqlquery-button" (click)="onBtnConnectClicked()" tam-button
                            [tamType]="'primary'" [tamSize]="'normal'"
                            [disabled]="!loginPassword.value || !loginUser.value || !serverip.value || isConnectedSuccess"
                            class="connect-button" [tamLoading]="isConnectting">
                            {{'general.connect' | stringLiterals}}
                        </button>
                    </div>
                    <div class="form-width">
                        <div class="tam-form-field" [ngClass]="{'has-error': database.invalid}">
                            <label class="caption-1">{{'general.database' | stringLiterals}} <span
                                    class="required warning-red">*</span></label>
                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" formControlName="database"
                                [data]="databaseList" class="kendo-dropdown"
                                (selectionChange)="handleDatabaseChange($event)" [filterable]="false">
                            </kendo-dropdownlist>
                            <div class="database-error">
                                <br>
                                <div class="tam-form-help" *ngIf="database.invalid && database.errors['required']">
                                    {{'general.required_error_message' | stringLiterals}}
                                </div>
                            </div>
                        </div>

                        <div class="tam-form-field tam-sqlQeury" [ngClass]="{'has-error': mdlQuery.invalid}">
                            <div>
                                <span class="caption-1">{{'general.sql_query' | stringLiterals}}<span
                                        class="required warning-red">*</span></span>
                            </div>
                            <div class="sqlQuery-content">
                                <textarea class="tam-textbox textbox-content" formControlName="mdlQuery"
                                    (keyup)="sqlQueryChanged()"></textarea>
                                <button tid="data-import-sqlquery-button" (click)="onBtnSQLQuery()" tam-button
                                    [tamType]="'primary'" [tamSize]="'normal'"
                                    [disabled]="!database.value || !mdlQuery.value || isQuerySuccess || !isConnectedSuccess || isQuerySuccess"
                                    class="run-button" [tamLoading]="isRunning">
                                    {{'general.run' | stringLiterals}}
                                </button>
                            </div>
                            <div class="tam-form-help tam-sqlQeury-error"
                                *ngIf="mdlQuery.invalid && mdlQuery.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="form-group">
                <label class="caption-1">{{'general.data_preview_x_rows' | stringLiterals: '5'}}</label>
                <div class="preview-area-blank" *ngIf="!pagePropertiesObject.previewRows">
                    <span>{{'general.no_data_preview' | stringLiterals}}</span>
                </div>
                <div class="preview-area" *ngIf="pagePropertiesObject.previewRows">
                    <table>
                        <tr>
                            <th *ngFor="let col of pagePropertiesObject.columns; let i = index" style>{{col.name}}</th>
                        </tr>
                        <tr *ngIf="isFlatfile">
                            <td *ngFor="let col of pagePropertiesObject.columns; let i = index">
                                <select class="form-control" #rowSetting [(ngModel)]="selectedPreviewTypeList[i]"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="handlePreviewOptionChange($event)">
                                    <option *ngFor="let option of columnTypeOptions" [ngValue]="option">
                                        {{option.name}}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr *ngFor="let row of pagePropertiesObject.previewRows; let i = index;
                        let isEven=even" [class.even]="isEven">
                            <td *ngFor="let cell of row; let j = index">{{cell}}</td>
                        </tr>
                    </table>
                </div>
                <br>
                <div class="form-group">
                    <label class="caption-1">{{'general.provider_column_settings' | stringLiterals}}</label>
                    <div class="column-setting-provider form-width">
                        <div class="tam-form-field mdl-input" [ngClass]="{'has-error': providerColumn.invalid}">
                            <label class="caption-2">{{'general.provider_column' | stringLiterals}} <span
                                    class="required warning-red">*</span></label>
                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                                formControlName="providerColumn" [data]="providerColumnList"
                                (filterChange)="handleProviderColumnFilter($event)" [filterable]="true"
                                class="column-setting-dropdownlist">
                            </kendo-dropdownlist>
                            <br>
                            <div>
                                <br>
                                <div class="tam-form-help"
                                    *ngIf="providerColumn.invalid && providerColumn.errors['required']">
                                    {{'general.required_error_message' | stringLiterals}}
                                </div>
                            </div>
                        </div>
                        <div class="tam-form-field mdl-input">
                            <label class="caption-2">{{'general.entity_reference' | stringLiterals}}</label>
                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                                formControlName="entityReferenceOptions" [data]="entityReferenceNameList"
                                class="column-setting-dropdownlist" (selectionChange)="handleSelectionChange($event)"
                                [filterable]="false">
                            </kendo-dropdownlist>
                        </div>
                        <div class="tam-form-field mdl-input-last"
                            *ngIf="pagePropertiesObject.entityReference.toUpperCase() === 'ALIAS'">
                            <label class="caption-2">{{'general.prefix' | stringLiterals}}</label>
                            <input type="text" class="form-control prefix-input column-setting-dropdownlist"
                                formControlName="aliasPrefix" [(ngModel)]="pagePropertiesObject.aliasPrefix">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
